import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Play, X } from "lucide-react";

const DISMISS_KEY = "premiere_dismissed_v1";

/* Dismissible launch-week strip announcing THE CASH VACUUM film.
   Sits above the sticky nav in normal flow so it scrolls away naturally. */
const PremiereBanner = () => {
  const [open, setOpen] = useState(() => {
    try {
      return !localStorage.getItem(DISMISS_KEY);
    } catch {
      return true;
    }
  });

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, "1");
    } catch {
      /* private mode — banner just hides for the session */
    }
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="premiere-banner"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="relative z-[60] overflow-hidden bg-gradient-to-r from-[#0a1128] via-[#141021] to-[#0a1128] border-b border-[#eec643]/40"
        >
          <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 sm:gap-5 px-4 py-2.5">
            <span className="hidden sm:inline-block rounded-full bg-[#eec643] text-black text-[9px] font-black uppercase tracking-[0.25em] px-2.5 py-1">
              Premiere
            </span>
            <p className="text-stone-200 text-xs sm:text-sm tracking-wide">
              <span className="font-bold text-[#eec643]" style={{ fontFamily: "Georgia, serif" }}>THE CASH VACUUM</span>
              <span className="hidden sm:inline"> — our ten-scene film is live. Watch cash become digital dollars and back.</span>
              <span className="sm:hidden"> — the film is live.</span>
            </p>
            <a
              data-testid="premiere-watch-btn"
              href="/film"
              className="inline-flex items-center gap-1.5 rounded-full border border-[#eec643]/70 text-[#eec643] text-[10px] sm:text-xs font-bold uppercase tracking-[0.2em] px-3.5 py-1.5 hover:bg-[#eec643] hover:text-black transition-colors"
            >
              <Play size={11} fill="currentColor" /> Watch
            </a>
            <button
              data-testid="premiere-dismiss-btn"
              onClick={dismiss}
              aria-label="dismiss premiere banner"
              className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-500 hover:text-stone-200 transition-colors"
            >
              <X size={15} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PremiereBanner;
